// Import SASS
import '../sass/style.scss'

// Node_modules
import objectFitImages from 'object-fit-images'

import modals from './modules/modals.js'

// Import scripts
import './modules/skip-link-focus-fix'
import initYoutubeVideos from './modules/init-after-youtube-api' // when videos are loaded on the page
import headerScroll from './modules/header';
import '../partials/navigation/menus/menus'
import '../partials/search/search'
import '../partials/instagram/instagram'
import '../partials/competitions/competitions'
import initSliders from '../partials/sliders/sliders'
import { initBlockSlider } from '../partials/blocks/block/block-slider'

window.onYouTubeIframeAPIReady = function() {
	initYoutubeVideos();
}

// Object-fit fix
objectFitImages()

// Init slider
let sliders = initSliders();
console.log(sliders);

//

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

AOS.init();

headerScroll('.header');



modals.init( {
  backspaceClose: false,
  modalActiveClass: 'active',
  callbackOpen: function ( toggle, modal ) {

//     var modal = document.querySelector(".modal");


     if (document.querySelector(".modal__button")) { 

      var modalbut = document.querySelector(".modal__button");

    modalbut.classList.add("animate__fadeInUp");
    modalbut.classList.add("animate__animated");
    modalbut.classList.add("active");

  }

    
    

  },
  callbackClose: function ( toggle, modal ) {

    
 //   var modal = document.querySelector(".modal");

    if (document.querySelector(".modal__button")) { 

      var modalbut = document.querySelector(".modal__button");

    modalbut.classList.add("animate__fadeInUp");
    modalbut.classList.add("animate__animated");
    modalbut.classList.add("active");

  }
    

  }


} );


if (document.querySelector(".modal__button")) { 

  var modal = document.querySelector(".modal");
  var modalbut = document.querySelector(".modal__button");

  // When the window is loaded....
  window.addEventListener("load", function() {

    

       modalbut.classList.add("animate__fadeInUp");
        modalbut.classList.add("animate__animated");
        modalbut.classList.add("active");
      
    



  });

}

const openpopups = document.querySelectorAll('.openpopup');

for (const openpopup of openpopups) {
  openpopup.addEventListener('click', function handleClick() {
    modals.openModal( null, '#popup' );
  });
}